/* eslint-disable react/prop-types */

import React from "react";

const Banner = ({ heading, bannerBackground, bannerFontColor, bannerFont }) => {
  return (
    <section
      className={`case-study-page__banner w-full sixteen-by-nine relative bg-${bannerBackground} text-${bannerFontColor} overflow-hidden`}
    >
      <div className="animation-appear-down case-study-page__banner__heading w-full h-full relative flex items-center justify-center mx-auto overflow-hidden text-center">
        <h1
          className={`pr-v1 xs:pr-v2 pl-v1 xs:pl-v2 d1 text-center whitespace-pre-wrap ${bannerFont}`}
        >
          {heading}
        </h1>
      </div>
    </section>
  );
};

export default Banner;
